// src/utils/stepUtils.ts
import { StepId, StepValidation } from "../types/studio.types";

export const canNavigateToStep = (
  targetStep: StepId,
  validation: StepValidation,
): boolean => {
  switch (targetStep) {
    case 1:
      return true;
    case 2:
      return validation.isStep1Valid;
    case 3:
      return validation.isStep1Valid && validation.isStep2Valid;
    case 4:
      return (
        validation.isStep1Valid &&
        validation.isStep2Valid &&
        validation.isStep3Valid
      );
    default:
      return false;
  }
};

export const getStepStatus = (
  stepId: StepId,
  validation: StepValidation,
): "completed" | "incomplete" | "locked" => {
  switch (stepId) {
    case 1:
      return validation.isStep1Valid ? "completed" : "incomplete";
    case 2:
      if (!validation.isStep1Valid) return "locked";
      return validation.isStep2Valid ? "completed" : "incomplete";
    case 3:
      if (!validation.isStep1Valid || !validation.isStep2Valid) return "locked";
      return validation.isStep3Valid ? "completed" : "incomplete";
    case 4:
      if (
        !validation.isStep1Valid ||
        !validation.isStep2Valid ||
        !validation.isStep3Valid
      )
        return "locked";
      return validation.isStep4Valid ? "completed" : "incomplete";
    default:
      return "locked";
  }
};
